import { Box, FormHelperText, Typography } from '@mui/material';
import { useState, useMemo } from 'react';
import OtpInput from 'react-otp-input';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { Formik } from 'formik';
import { LoginLayout } from '../../commonComponents';
import { MFSubmitButton } from '../../../lib/formik';
import { verifyOtp } from '../../../redux-store/actions/onBoarding';
import { verifyOtpPayload } from '../../../redux-store/types/api-types';
import { VerifyOtp } from '../../../redux-store/actions/userManagement';

const initialValues = { OTP: '' };

export default function InvestorRiskMobileOtp(): JSX.Element {
    const dispatch = useDispatch();
    const history = useHistory();
    const [error, setError] = useState<string>('');
    const location = useLocation<any>();
    const UserData = location.state?.decryptedData;
    console.log(UserData)

    const handleSubmit = async (values: { OTP: string }) => {
        const { OTP } = values;

        if (!OTP || OTP.length !== 6) {
            setError('Enter a valid 6-digit OTP');
            return;
        }

        if (!UserData) {
            setError("Client details are missing");
            return;
        }

        const payload: verifyOtpPayload = {
            mobileNumber: UserData.mobile,
            otp: Number(OTP),
        };

        try {
            const response = await dispatch(VerifyOtp(payload)) as unknown as any;

            if (response && response.Status === "OTP Validated Successfully") {
                console.log("OTP verified successfully:", response);
                history.push('/investor-risk-profiledetails', { UserData });
            } else {
                setError(response?.message || "Invalid OTP. Please try again.");
            }
        } catch (apiError) {
            console.error("Error verifying OTP:", apiError);
            setError("Failed to verify OTP. Please try again.");
        }
    };

    const maskValue = (value: any, isEmail = false) => {
        if (!value) return value;
        if (isEmail) {
            return value.length <= 8 ? value : `${value.slice(0, 2)}${'*'.repeat(value.length - 8)}${value.slice(-6)}`;
        }
        return value.length <= 4 ? value : `${value.slice(0, 2)}${'*'.repeat(value.length - 4)}${value.slice(-2)}`;
    };

    return (
        <LoginLayout LoginText="Login with OTP">
            <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                {({ values, setValues, handleSubmit }) => (
                    <Box component="form" noValidate onSubmit={handleSubmit}>
                        <Typography sx={{ color: 'primary.main', textAlign: 'center', mb: 3.5 }}>
                            An OTP has been sent to your{' '}
                            {/* <Typography component="span" sx={{ color: 'gray', fontWeight: 'bold' }}>{` ${maskValue(UserData?.mobile)} `}</Typography> */}
                            {UserData?.email && (
                                <Typography component="span">
                                    email Id{' '}
                                    <Typography component="span" sx={{ wordBreak: 'break-all', color: 'grey', fontWeight: 'bold' }}>
                                        {maskValue(UserData?.email, true)}
                                    </Typography>
                                </Typography>
                            )}
                        </Typography>
                        <Box sx={{ mb: 0, '.otp-input': { input: { width: { xs: '37px !important', md: '45px !important' }, fontSize: { xs: '20px !important', md: '30px !important' }, margin: { xs: '2px !important', md: '4px !important' } } } }}>
                            <OtpInput
                                value={values.OTP}
                                onChange={(OTP: string) => setValues({ OTP })}
                                numInputs={6}
                                hasErrored={!!error}
                                isInputNum
                                isInputSecure
                                shouldAutoFocus
                                containerStyle={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}
                                inputStyle={{ padding: '5px 10px', borderRadius: '5px', fontSize: '30px' }}
                                errorStyle={{ border: '2px solid red', color: 'red' }}
                                focusStyle={{ outline: 'none' }}
                                className="otp-input"
                            />
                            {!!error && (
                                <FormHelperText error sx={{ mt: 2, textAlign: 'center', fontSize: '14px' }}>
                                    {error}
                                </FormHelperText>
                            )}
                        </Box>
                        <Box sx={{ textAlign: 'center' }}>
                            <MFSubmitButton label="Submit" />
                        </Box>
                    </Box>
                )}
            </Formik>
        </LoginLayout>
    );
}
